<template>
  <div class="agreement">
    <div class="text" v-text="getSplitText('{privacy_policy}', 0)"></div>
    <a href="#" v-text="privacyPolicy" @click.prevent="clicked"></a>
    <div class="text" v-text="getSplitText('{privacy_policy}', 1)"></div>
    <div>
      <img class="garena-logo" src="https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/garena_logo.png" />
    </div>
  </div>
</template>

<script>
import { EVENT } from '@/constants/event'
import SplitTextMixin from './mixins/SplitTextMixin'

export default {
  name: 'GSAgreement',
  mixins: [SplitTextMixin],
  props: {
    text: {
      type: String,
      required: true
    },
    privacyPolicy: {
      type: String,
      required: true
    }
  },
  methods: {
    clicked () {
      this.$emit(EVENT.CLICKED)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.agreement {
  position: relative;
  padding: $base-size * 20 0;
  letter-spacing: 0;
  font-size: $base-size * 25;
  line-height: $base-size * 42;
  overflow: hidden;

  a {
    color: #AEBBD2;
  }

  .text {
    color: #AEBBD2;
    opacity: 0.45;
    display: inline;
  }
}
.garena-logo {
  float: right;
  width: $base-size * 300;
  margin-right: $base-size * 20;
}
</style>



// WEBPACK FOOTER //
// src/components/GSAgreement.vue